import { z } from "zod";

//? DTO
export const ReservationServiceClientDtoSchema = z.object({
    ReservationId: z.number(),
    ServiceId: z.number(),
    ClientId: z.number(),
  });

  export type ReservationServiceClientDto = z.infer<
    typeof ReservationServiceClientDtoSchema
  >;
  
  export const ReservationServiceClientSchema = z.object({
    serviceId: z.number(),
    reservationId: z.number(),
    clientId: z.number(),
  });

  export type ReservationServiceClient = z.infer<
    typeof ReservationServiceClientSchema
  >;


  export function ReservationServiceClientFromDto(
    dto: ReservationServiceClientDto
  ): ReservationServiceClient {
    return {
      serviceId: dto.ServiceId,
      reservationId: dto.ReservationId,
      clientId: dto.ClientId,
    };
  }
  export function ReservationServiceClientToDto(
    model: ReservationServiceClient
  ): ReservationServiceClientDto {
    return {
      ServiceId: model.serviceId,
      ClientId: model.clientId,
      ReservationId: model.reservationId,
    };
  }
  